// prettier-ignore
const defaultRoutes = [
  {
    path: "/",
    redirect: "/logs",
  },
  {
    path: "/expired",
    meta: {
      name: "세션 만료",
      class: ["!w-full", "!h-full", "!p-0", "!m-0", "bg-coolGray-50"],
    },
    components: {
      content: () => import("../pages/default/expired/ExpiredPage.vue"),
    },
  },
  {
    path: "/:catchAll(.*)*",
    meta: {
      name: "존재하지 않는 페이지",
      class: ["!w-full", "!h-full", "!p-0", "!m-0", "bg-coolGray-50"],
    },
    components: {
      content: () => import("../pages/default/not-found/NotFoundPage.vue"),
    },
  },
];

export default defaultRoutes;
